import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, MoreVertical } from "lucide-react";
// eslint-disable-next-line no-unused-vars
const _unused = Menu;

const links = [
  { label: "Produtos", href: "/#produtos" },
  { label: "Manifesto", href: "/#manifesto" },
  { label: "Recomendador IA", href: "/#recomendador" },
  { label: "Contato", href: "/#contato" },
];

const Logo = () => (
  <a href="/#top" className="flex items-center" data-testid="nav-logo">
    <img src="/logo-full.png" alt="JeaxLabs" className="h-7 md:h-8 w-auto" />
  </a>
);

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled || open ? "bg-ink/80 backdrop-blur-xl border-b border-white/10" : "border-b border-transparent"
      }`}
      data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-5 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
               className="font-mono text-xs uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors duration-300">
              {l.label}
            </a>
          ))}
          <Link to="/login" data-testid="nav-admin-link"
                className="font-mono text-xs uppercase tracking-[0.2em] px-4 py-2 border border-white/20 hover:bg-white hover:text-ink transition-colors duration-300">
            Área do Cliente
          </Link>
        </nav>
        <button onClick={() => setOpen(!open)} data-testid="nav-hamburger"
                className="md:hidden p-2 -mr-2 text-white" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <MoreVertical className="w-6 h-6" />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden border-t border-white/10" data-testid="mobile-menu">
            <div className="px-5 py-4 flex flex-col gap-1">
              {links.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)}
                   className="font-mono text-sm uppercase tracking-[0.2em] text-white/70 py-3 border-b border-white/5">
                  {l.label}
                </a>
              ))}
              <Link to="/login" onClick={() => setOpen(false)} data-testid="mobile-admin-link"
                    className="mt-3 text-center font-mono text-xs uppercase tracking-[0.2em] px-4 py-3 bg-cobalt text-white">
                Área do Cliente
              </Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
